import { useState } from 'react'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export const useCaptureScreenshot = (ref) => {
  const [isCapturing, setIsCapturing] = useState(false)

  const captureScreenshot = async (fileName = 'document.pdf') => {
    if (!ref?.current) {
      console.error('PDF generation error: ref is null')
      return
    }

    try {
      setIsCapturing(true)
      const element = ref.current
      const padding = 8

      // Add print-mode class to show print-specific elements
      element.classList.add('print-mode')

      // Apply temporary scale for better capture
      element.style.transform = 'scale(0.8)'
      element.style.transformOrigin = 'top left'
      element.style.width = '125%'
      element.style.fontSize = '0.85em'

      await new Promise((r) => setTimeout(r, 200))

      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: true,
        scale: 2,
        backgroundColor: '#FFFFFF',
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      })

      // Reset styling
      element.style.transform = ''
      element.style.width = ''
      element.style.fontSize = ''
      element.classList.remove('print-mode')

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')

      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const imgWidth = pdfWidth - padding * 2
      const imgHeight = (canvas.height * imgWidth) / canvas.width

      const scaleToFit = Math.min(1, (pdfHeight - padding * 2) / imgHeight)
      const finalWidth = imgWidth * scaleToFit
      const finalHeight = imgHeight * scaleToFit

      const xOffset = padding + (pdfWidth - padding * 2 - finalWidth) / 2
      const yOffset = padding

      pdf.addImage(imgData, 'PNG', xOffset, yOffset, finalWidth, finalHeight)
      pdf.save(fileName)
    } catch (err) {
      console.error('PDF generation error:', err)
    } finally {
      // Ensure print-mode class is removed even if there's an error
      ref.current?.classList.remove('print-mode')
      setIsCapturing(false)
    }
  }

  return { isCapturing, captureScreenshot }
}
